<template>
  <v-chart :option="option" autoresize style="width:100%;height:260px;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

const props = defineProps<{
  batteryLevel: number;
  chargeLimitSoc: number;
}>();

const option = computed(() => {
  const C = useChartTheme();
  return {
    backgroundColor: C.paper,
    grid: { top: 16, bottom: 40, left: 110, right: 24 },
    xAxis: {
      type: 'value',
      min: 0,
      max: 100,
      axisLabel: { formatter: '{value}%', color: C.muted, fontSize: 11, fontFamily: 'Inter' },
      splitLine: { lineStyle: { color: C.line } },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'category',
      data: ['Charge Limit', 'Battery Level'],
      axisLabel: { color: C.muted, fontSize: 12, fontFamily: 'Inter', fontWeight: 700 },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    series: [{
      type: 'bar',
      data: [props.chargeLimitSoc, props.batteryLevel],
      barWidth: 28,
      itemStyle: {
        color: (p: { dataIndex: number }) => p.dataIndex === 1 ? C.accent : C.warn,
        borderRadius: [0, 6, 6, 0],
      },
      label: {
        show: true,
        position: 'right',
        color: C.ink,
        fontSize: 13,
        fontWeight: 700,
        fontFamily: 'Inter',
        formatter: '{c}%',
      },
    }],
  };
});
</script>
